import { render, staticRenderFns } from "./AutoAnswer.vue?vue&type=template&id=799bfe3e&scoped=true"
import script from "./AutoAnswer.vue?vue&type=script&lang=js"
export * from "./AutoAnswer.vue?vue&type=script&lang=js"
import style0 from "./AutoAnswer.vue?vue&type=style&index=0&id=799bfe3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799bfe3e",
  null
  
)

export default component.exports